// skipcq: JS-W1028
import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../utils/firebase';
import { ENGAGE_FIRST_TOUCH_METRICS_COLLECTION } from '../utils/firestoreCollections';

const LATEST_DOC_ID = 'latest';

function useFirstTouchMetrics() {
  const [snapshot, setSnapshot] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchSnapshot = async () => {
      try {
        if (!cancelled) {
          setLoading(true);
          setError(null);
        }

        const reportRef = doc(db, ENGAGE_FIRST_TOUCH_METRICS_COLLECTION, LATEST_DOC_ID);
        const documentSnap = await getDoc(reportRef);
        if (cancelled) {
          return;
        }

        if (!documentSnap.exists()) {
          setSnapshot(null);
          return;
        }

        const data = documentSnap.data();
        setSnapshot({
          id: documentSnap.id,
          date: typeof data.date === 'string' ? data.date : 'latest',
          metrics:
            typeof data.metrics === 'object' && data.metrics !== null ? data.metrics : {},
        });
      } catch (fetchError) {
        console.error('useFirstTouchMetrics fetch error', fetchError);
        if (!cancelled) {
          setError('Failed to load first-touch hotspot metrics');
          setSnapshot(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchSnapshot();
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    snapshot,
    loading,
    error,
  };
}

export default useFirstTouchMetrics;
